module.exports = __webpack_public_path__ + "static/media/IsDB_logo.efc6684f.jpg";